import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import {
  selectedPin,
  mapFilters,
  selectedTab,
} from '../actions/dive-guide-actions'
import {
  selectedCurrency,
  setCurrency,
  pageLoader,
} from '../actions/main-actions'
import {
  currencyDirective,
  convertDjangoRenderedPrice,
  hideMobileAppPromotion,
  diveGuidesHeaderFooter,
  showModalOnClick,
  collapseItems,
} from '../directives'
import ErrorHandler from '../components/ErrorHandler'

// import * as fx from '../libs/money'
import { getLanguage, getTranslations } from 'utils'
import { toast } from 'react-toastify'
import 'babel-polyfill'
import 'whatwg-fetch'
import 'react-toastify/dist/ReactToastify.css'
import HeroSearch from '../components/homepage/Hero'
import SliderDg from '../components/dive-guides/SliderDg'
import PadiSearch from '../components/dive-guides/PadiSearch'
import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-locale/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import 'finally-polyfill'
import { createRoot } from 'react-dom/client'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: [
      'AbortError',
      'UnhandledRejection',
      'Unexpected token o in JSON at position 1',
      'Anonymous function(/gtm.js)',
      "undefined is not an object (evaluating 'd.appendChild')",
      'chrome-extension',
      'gtm',
      'Illegal invocation',
      "Can't find variable: setIOSParameters",
      '(app-modern)',
      'd is undefined',
    ],
  })
}

let store = createStore(
  combineReducers({
    pageLoader,
    selectedPin,
    mapFilters,
    selectedTab,
    selectedCurrency,
  }),
)

let language = getLanguage()
let messages = {}
toast.configure()

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  getTranslations(language, renderApp)
} else {
  renderApp()
}

function renderApp(translatedStrings) {
  if(translatedStrings) {
    messages = translatedStrings
  }
  renderElement('homepage-hero-search', HeroSearch, {
    searchLaUrl: window.searchLaUrl,
    isDiveGuides: true,
  })

  renderElement('top-guides', SliderDg, {
    data: window.topLocations,
    view: 5,
    regionIdentifier: 'dive-guides-localised',
    name: 'top-locations',
  })

  renderElement('top-sites-categories', SliderDg, {
    data: window.topSites,
    view: 4,
    regionIdentifier: 'dive-site-types',
    name: 'top-sites-categories',
  })

  renderElement('padi-search', PadiSearch)
  renderElement('padi-search-mobile', PadiSearch)

  hideMobileAppPromotion()
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
  collapseItems()
  convertDjangoRenderedPrice(renderElement)
  diveGuidesHeaderFooter()
  showModalOnClick(renderElement)
}

function renderElement(elem, ComponentToRender, props) {
  let element
  if(typeof elem === 'string') {
    element = document.getElementById(elem)
  } else {
    element = elem
  }

  if(element) {
    const root = createRoot(element)
    root.render(
      <IntlProvider
        locale={language === 'ach' ? 'en' : language}
        messages={messages}
        textComponent='span'
      >
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
    )
  }
}
